import { type MantineColor } from '@mantine/core';

export const SelfServeIntent = {
  Troubleshooting: 'troubleshooting',
  Guiding: 'guiding',
  Lookup: 'lookup',
  OffTopic: 'off_topic',
  Other: 'other',
} as const;
export type SelfServeIntent =
  (typeof SelfServeIntent)[keyof typeof SelfServeIntent];

export const SelfServeSignal = {
  Pushback: 'pushback',
  NegativeSentiment: 'negative_sentiment',
} as const;
export type SelfServeSignal =
  (typeof SelfServeSignal)[keyof typeof SelfServeSignal];

export const SELF_SERVE_INTENT_OPTIONS: {
  value: SelfServeIntent;
  label: string;
}[] = [
  { value: SelfServeIntent.Troubleshooting, label: 'Troubleshooting' },
  { value: SelfServeIntent.Guiding, label: 'Guiding' },
  { value: SelfServeIntent.Lookup, label: 'Lookup' },
  { value: SelfServeIntent.OffTopic, label: 'Off-Topic' },
  { value: SelfServeIntent.Other, label: 'Other' },
];

export const SELF_SERVE_SIGNAL_OPTIONS: {
  value: SelfServeSignal;
  label: string;
}[] = [
  { value: SelfServeSignal.Pushback, label: 'Pushback' },
  { value: SelfServeSignal.NegativeSentiment, label: 'Negative sentiment' },
];

export const SELF_SERVE_INTENT_LABELS: Record<SelfServeIntent, string> =
  Object.fromEntries(
    SELF_SERVE_INTENT_OPTIONS.map((option) => [option.value, option.label]),
  ) as Record<SelfServeIntent, string>;

export const SELF_SERVE_SIGNAL_LABELS: Record<SelfServeSignal, string> =
  Object.fromEntries(
    SELF_SERVE_SIGNAL_OPTIONS.map((option) => [option.value, option.label]),
  ) as Record<SelfServeSignal, string>;

export const SELF_SERVE_INTENT_COLORS: Record<SelfServeIntent, MantineColor> = {
  [SelfServeIntent.Troubleshooting]: 'cyan',
  [SelfServeIntent.Guiding]: 'teal',
  [SelfServeIntent.Lookup]: 'blue',
  [SelfServeIntent.OffTopic]: 'gray',
  [SelfServeIntent.Other]: 'primary',
};

export const SELF_SERVE_SIGNAL_DESCRIPTIONS: Record<SelfServeSignal, string> = {
  [SelfServeSignal.Pushback]: 'User questioned or corrected the answer',
  [SelfServeSignal.NegativeSentiment]:
    'User expressed frustration with the answer',
};

export const SELF_SERVE_SIGNAL_COLORS: Record<SelfServeSignal, MantineColor> = {
  [SelfServeSignal.Pushback]: 'red',
  [SelfServeSignal.NegativeSentiment]: 'orange',
};
